import { useCallback, useState } from 'react';
import { type IAdvancedSelectColumns } from '../IAdvancedSelectColumns.ts';
import { type IRuntimeWidgetAdvancedOption } from '../IAdvancedSelectWidget.ts';
import {
  matchRecordToSearchTokens,
  parseSearchTokens,
} from '../table/tableUtils.ts';

/**
 * Hook per la gestione della ricerca globale nella tabella di selezione avanzata.
 */
export function useAdvancedSelectSearch(columns: IAdvancedSelectColumns[]) {
  const [searchValue, setSearchValue] = useState('');

  const filterData = useCallback(
    (data: IRuntimeWidgetAdvancedOption[]): IRuntimeWidgetAdvancedOption[] => {
      const tokens = parseSearchTokens(searchValue);
      if (tokens.length === 0) return data;

      return data.filter(option =>
        matchRecordToSearchTokens(option, tokens, columns),
      );
    },
    [searchValue, columns],
  );

  return { searchValue, setSearchValue, filterData };
}
